import { LocaleUser } from '../en/user'

const user: LocaleUser = {
  changePass: 'Tukar Kata Laluan',
  editProfile: 'Sunting Profil',
  emailVerifiedSuccess: 'E-mel berjaya disahkan.',
  emailCantVerified: 'E-mel anda tidak dapat disahkan.',
  changeLang: 'Tukar Bahasa',
  english: 'Bahasa Inggeris',
  vietnamese: 'Bahasa Vietnam',
  chineseSimplified: 'Bahasa Cina (Dipermudahkan)',
  spanish: 'Bahasa Sepanyol',
  chineseTraditional: 'Bahasa Cina (Tradisional)',
  malay: 'Bahasa Melayu',
}

export default user
